import script from "./ColumnConfigDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnConfigDialog.vue?vue&type=script&setup=true&lang=js"

import "./ColumnConfigDialog.vue?vue&type=style&index=0&id=ede4d83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ede4d83e"]])

export default __exports__